import { useLocation } from "react-router-dom";

const FILA1 = [
    { key: "conTelefono",          icon: "bi-telephone",         label: "Con teléfono" },
    { key: "conInfoBancaria",      icon: "bi-bank",              label: "Info bancaria" },
    { key: "conInfoPersonal",      icon: "bi-person-check",      label: "Perfil personal" },
    { key: "conInfoProfesional",   icon: "bi-briefcase",         label: "Perfil profesional" },
    { key: "verificacionExitosa",  icon: "bi-patch-check",       label: "Verificación aprobada" },
    { key: "verificacionPendiente",icon: "bi-hourglass-split",   label: "Verificación pendiente" },
    { key: "verificacionNegada",   icon: "bi-patch-exclamation", label: "Verificación negada" },
];

const FILA2 = [
    { key: "modoVendedor",   icon: "bi-shop",        label: "Modo vendedor" },
    { key: "aceptaMarketing",icon: "bi-megaphone",   label: "Acepta marketing" },
    { key: "conReferido",    icon: "bi-person-plus", label: "Con referido" },
];

const FILA3 = [
    { key: "conServiciosBorrador",     icon: "bi-pencil-square", label: "Borrador" },
    { key: "conServiciosAprobados",    icon: "bi-check-circle",  label: "Publicado" },
    { key: "conServiciosDesaprobados", icon: "bi-x-circle",      label: "Desaprobado" },
    { key: "conServiciosPausa",        icon: "bi-pause-circle",  label: "Pausado" },
];

const VACIO = {
    conTelefono: false, conInfoBancaria: false, conInfoPersonal: false,
    conInfoProfesional: false, verificacionExitosa: false, verificacionPendiente: false,
    verificacionNegada: false, modoVendedor: false, aceptaMarketing: false, conReferido: false,
    conServiciosBorrador: false, conServiciosAprobados: false, conServiciosDesaprobados: false, conServiciosPausa: false,
};

function ChipFila({ chips, filtros, onToggle }) {
    return chips.map(({ key, icon, label }) => (
        <button
            key={key}
            type="button"
            className={`btn btn-sm rounded-pill ${filtros[key] ? "btn-dark" : "btn-outline-secondary"}`}
            style={{ fontSize: "0.78rem" }}
            onClick={() => onToggle(key)}
        >
            <i className={`${icon} me-1`}></i>{label}
        </button>
    ));
}

function FiltrosUsuarios({ filtros, onChange }) {
    const { pathname } = useLocation();
    const mostrarServicios = pathname.includes("servicios-por-usuarios");

    function toggle(key) {
        onChange({ ...filtros, [key]: !filtros[key] });
    }

    const hayFiltros = Object.values(filtros).some(Boolean);

    return (
        <div className="d-flex flex-column gap-2">
            <div className="d-flex align-items-center gap-2 flex-wrap">
                <span className="text-muted small fw-semibold" style={{ fontSize: "0.8rem", minWidth: 52 }}>Perfil:</span>
                <ChipFila chips={FILA1} filtros={filtros} onToggle={toggle} />
            </div>
            <div className="d-flex align-items-center gap-2 flex-wrap">
                <span className="text-muted small fw-semibold" style={{ fontSize: "0.8rem", minWidth: 52 }}>Cuenta:</span>
                <ChipFila chips={FILA2} filtros={filtros} onToggle={toggle} />
            </div>
            {mostrarServicios && (
                <div className="d-flex align-items-center gap-2 flex-wrap">
                    <span className="text-muted small fw-semibold" style={{ fontSize: "0.8rem", minWidth: 52 }}>Servicios:</span>
                    <ChipFila chips={FILA3} filtros={filtros} onToggle={toggle} />
                </div>
            )}
            {hayFiltros && (
                <div>
                    <button
                        type="button"
                        className="btn btn-sm btn-link text-danger p-0 text-decoration-none"
                        style={{ fontSize: "0.78rem" }}
                        onClick={() => onChange(VACIO)}
                    >
                        <i className="bi bi-x me-1"></i>Limpiar
                    </button>
                </div>
            )}
        </div>
    );
}

export default FiltrosUsuarios;
